import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { purgeOffline } from "./offline";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  useEffect(() => {
    if (window.location.pathname.startsWith("/portal")) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);
  const login = async (email, password, remember = false) => {
    const r = await api.post("/auth/login", { email, password, remember });
    setUser(r.data);
    return r.data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    await purgeOffline();
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
